import { graphql } from 'gql.tada';
import { useMutation } from '@apollo/client';

const GetReenrollmentFormMutation = graphql.persisted(
  "GetReenrollmentForm",
  graphql(`
    mutation GetReenrollmentForm($token: String!) {
      getReenrollmentForm(input: {token: $token}) {
        familyEnrollment {
          id
          state
          enrollmentKind
          family { id name }
          studentEnrollments {
            id state gradeLevel
            person { id firstName lastName dateOfBirth gender }
          }
        }
        formMetadata
        formAnswers
        schema
        schemaHints { path schemaKey entityIdPath }
        tuitionOptions
        paymentOptions
        enrollmentFee
        gradeLevels
        schoolYearName
        schoolYearStartDate
        schoolYearEndDate
        familyName
        persistedNewStudents
        userErrors { message path }
      }
    }
  `)
);

export { GetReenrollmentFormMutation };

export function useGetReenrollmentForm() {
  return useMutation(GetReenrollmentFormMutation);
}
